// Verify email page

import Layout from '../components/Layout';
import VerifyEmailCard from '../components/VerifyEmailCard';

export default function PageVerifyEmail() {
  return (
    <Layout screenSized className='page-verify-email'>
      <VerifyEmailCard />
    </Layout>
  );
}
